export const initFilterPosts = (termSelector = '') => {
    if (termSelector == '')
        return;
    let url = window.location.href;
    const selector = document.querySelector(termSelector);
    selector === null || selector === void 0 ? void 0 : selector.addEventListener('click', (event) => {
        event.target.parentElement.classList.toggle('active');
    });
    selector === null || selector === void 0 ? void 0 : selector.addEventListener('mouseleave', (event) => {
        setTimeout(() => {
            event.target.classList.remove('active');
        }, 300);
    });
    const inputs = selector === null || selector === void 0 ? void 0 : selector.querySelectorAll('input');
    let termsArray = [];
    let params = '';
    const storageTerms = window.sessionStorage;
    if (!window.location.search) {
        storageTerms.clear();
    }
    inputs &&
        [...inputs].forEach((input) => {
            let taxonomyName = input.name;
            let termValue = input.value;
            let getStorageTerms = get_url_parameter(taxonomyName);
            if (getStorageTerms == '') {
                getStorageTerms = storageTerms.getItem(taxonomyName);
            }
            if (getStorageTerms != null) {
                const getStorageTermsArray = getStorageTerms.split(',');
                [...getStorageTermsArray].forEach((el) => {
                    if (el == termValue) {
                        input.checked = true;
                        input.parentElement.classList.add('active');
                        termsArray.push(termValue);
                    }
                });
            }
            input.addEventListener('change', (event) => {
                event.preventDefault();
                let termChecked = input.checked;
                if (termChecked && !termsArray.includes(termValue)) {
                    termsArray.push(termValue);
                }
                else if (!termChecked && termsArray.includes(termValue)) {
                    termsArray = termsArray.filter((el) => el != termValue);
                }
                if (termsArray.length >= 1) {
                    storageTerms.setItem(taxonomyName, termsArray.toString());
                }
                else {
                    storageTerms.removeItem(taxonomyName);
                    params = '';
                }
                let i = 0;
                for (const [key, value] of Object.entries(storageTerms)) {
                    if (key == 'post_roles' || key == 'post_themes' || key == 'post_types') {
                        if (i == 0) {
                            params = `${key}=${value}`;
                        }
                        else {
                            params += `&${key}=${value}`;
                        }
                    }
                    i++;
                }
                history.replaceState(null, '', '?' + params);
                setTimeout(() => {
                    let newUrl = window.location.href;
                    if (newUrl != url) {
                        window.location.href = newUrl;
                    }
                }, 500);
            });
        });
};
export const mobileFilterButton = (button = '') => {
    if (button == '')
        return;
    const selector = document.querySelector(button);
    selector === null || selector === void 0 ? void 0 : selector.addEventListener('click', (event) => {
        event.target.parentElement.classList.toggle('active');
    });
};
function get_url_parameter(param) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param);
}
